import { useFormControl, type FormControlProps } from "@mongez/react-form";
import ReactSlider from "react-slider";

type SliderInputProps = FormControlProps & {
  value: [number | string, number | string];
};

export function SliderRangeInput({
  value,
  onChange,
  ...props
}: SliderInputProps) {
  const { changeValue } = useFormControl({
    ...props,
    value,
    onChange,
  });

  return (
    <>
      <ReactSlider
        className="range-slider"
        min={0}
        max={100}
        value={value}
        onChange={(values) => changeValue([values[0], values[1]])}
        {...props}
      />
    </>
  );
}
